@let isDirty = this.autoSaveService.isDirty();
<kendo-appbar position="top" class="appbar">
    <kendo-appbar-section>
        <img src="../../../assets/logo-negative.svg" [height]="50" alt="logo" />
        @if (this.showSaveButon) {
            <button kendoButton (click)="this.kopModulesService.save('')">{{'Opslaan' | translate: 'Opslaan'}}{{isDirty ? "*" : ""}}</button>
        }
        <kendo-dropdownbutton [data]="this.fileOptions" [themeColor]="'light'" [fillMode]="'link'">{{'Bestand' | translate: 'Bestand'}}</kendo-dropdownbutton>

        <kendo-dropdownbutton [data]="this.configOptions" [themeColor]="'light'" [fillMode]="'link'">{{'Config' | translate: 'Config'}}</kendo-dropdownbutton>
        <button kendoButton (click)="this.showKanaalOverview.set(true)" [themeColor]="'light'" [fillMode]="'link'">{{'Kanalen' | translate: 'Kanalen'}}</button>
        <system-def></system-def>
        <pdf-debug-dialog></pdf-debug-dialog>
        @if (this.electronAPI.isSercom()) {
            <kendo-dropdownbutton [data]="this.extraOptions" [themeColor]="'light'" [fillMode]="'link'">Extra</kendo-dropdownbutton>            
            @if (this.jsBridgeService.isDev()) {
                <translation-editor />
            }
        }
    </kendo-appbar-section>
    <kendo-appbar-spacer>

    </kendo-appbar-spacer>
    <kendo-appbar-section>
        <ng-content></ng-content>
        <kendo-dropdownlist style="width: 75px; color: white" [fillMode]="'flat'" [data]="this.translateService.availableLanguages" 
            [(value)]="this.translateService.currentLanguage"></kendo-dropdownlist>
    </kendo-appbar-section>
</kendo-appbar>
<global-alarm-texts [isEditing]="this.editVrijAlarmen()" (onDone)="this.editVrijAlarmen.set(false)" />
<global-uren-teksten [isEditing]="this.editUren()" (onDone)="this.editUren.set(false)" />
<global-config [isEditing]="this.editGlobalConfig()" (onDone)="this.editGlobalConfig.set(false)" />
<global-config-extra [isEditing]="this.editGlobalConfigExtra()" (onDone)="this.editGlobalConfigExtra.set(false)" />
<modbus-network [isEditing]="this.editModbus()" (onDone)="this.editModbus.set(false)" />
<kanaal-overview-dialog [isShowing]="this.showKanaalOverview()" (onDone)="this.showKanaalOverview.set(false)" [assign]="this.assign()" />
<xmlcompare #xmlCompare></xmlcompare>
<legacy-list [isEditing]="this.generateList()" (onDone)="this.generateList.set(false)"></legacy-list>
<unlock [isEditing]="this.unlock()" (onDone)="this.unlock.set(false)"></unlock> 
<modules-meta-overview #modulesMetaOverview/>
<kop-history #kopHistory/>